var _path, _rect, _path2, _path3, _path4, _rect2, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 3H10",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 9,
    height: 11,
    rx: 1.5,
    stroke: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5H10.5",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10H10.5",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5H7",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 5,
    y: 4,
    width: 6,
    height: 5,
    rx: 1,
    fill: "#002A69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.5,
    r: 1,
    fill: "#002A69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3915 8.89999C9.77576 8.89999 10.0981 8.59351 9.97236 8.24559C9.86996 7.96224 9.70139 7.70184 9.47591 7.48578C9.08448 7.11071 8.55357 6.89999 8 6.89999C7.44643 6.89999 6.91552 7.11071 6.52409 7.48578C6.29861 7.70184 6.13004 7.96224 6.02764 8.24559C5.9019 8.59351 6.22424 8.89999 6.6085 8.89999L9.3915 8.89999Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientInfo);
export default __webpack_public_path__ + "static/media/Patient_info.2f7f4e4bf6d4a47955b92ef0ebfebef0.svg";
export { ForwardRef as ReactComponent };